export const RAW = 'RAW';
export const VALUE = 'VALUE';
